import React from "react";

interface ArrowsProps {
  upColor?: string;
  downColor?: string;
  size?: number;
}

const SortIcon: React.FC<ArrowsProps> = ({
  upColor = "black",
  downColor = "black",
  size = 24,
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path d="M12 4L6 10H18L12 4Z" fill={upColor} />
      <path d="M12 20L18 14H6L12 20Z" fill={downColor} />
    </svg>
  );
};

export default SortIcon;
